"use strict";

exports.__esModule = true;

var state_1 = require("../../store/state");

var dispatch_1 = require("../../store/dispatch");

var actions_1 = require("../../store/actions");

function increment(label) {
  dispatch_1["default"](actions_1.count(label));
  var times = state_1.state.count[label];
  return {
    method: 'log',
    data: [label + ": " + times]
  };
}

exports.increment = increment;